export default class TeamModal {
    constructor () {
        this.modal = document.querySelector('.modal-team')

        // If there's no team modal, return
        if (!this.modal)
            return

        this.modal.addEventListener(
            'show.bs.modal',
            this.control.bind(this)
        )
    }

    control (el) {
        const trigger = el.relatedTarget

        if (!trigger)
            return

        const { teamId } = trigger.dataset
        const content = document.querySelector(`[data-team-content="${teamId}"]`)
        const popup = this.modal.querySelector('[data-team-popup]')
        console.log(teamId, content, popup)

        if (content && popup)
            popup.innerHTML = content.innerHTML
    }
}
